import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Nav/Navbar';
import Home from './pages/Home';
import BeyondPrejudice from './pages/books/BeyondPrejudice';
import BeyondPrejudiceSample from './pages/books/BeyondPrejudiceSample';
import WhenTheButterfliesAreGone from './pages/books/WhenTheButterfliesAreGone';
import WhenTheButterfliesAreGoneSample from './pages/books/WhenTheButterfliesAreGoneSample';
import About from './pages/About';
import Contact from './pages/Contact';
import Newsletter from './newsletter/Newsletter';
import PrivacyPolicy from './privacy-policy/PrivacyPolicy';

function App() {
  return (
    <Router>

      <Navbar />

      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/beyond-prejudice" element={<BeyondPrejudice />} />
        <Route path="/beyond-prejudice-sample" element={<BeyondPrejudiceSample />} />
        <Route path="/when-the-butterflies-are-gone" element={<WhenTheButterfliesAreGone />} />
        <Route path="/when-the-butterflies-are-gone-sample" element={<WhenTheButterfliesAreGoneSample />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      </Routes>

    </Router>
  );
}

export default App;
